import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
  padding-left:250px;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const DivCurso = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
`;
export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;
export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;

  color: #000000;

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  display: inline-block;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const Div = styled.div`
  width: 33%;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
`;
export const DivIcon = styled.div`
  align-items: center;
  justify-content: center;
  margin-top: 0.8rem;
`;
export const DivConteudo = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const DivTitulo = styled.div`
  width: 100%;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
`;

export const Label = styled.label`
  font-size: 0.92857143em;
  font-weight: 700;
`;
export const Select = styled.select`
  display: block;
  height: auto;
  width: 100%;
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.28571429rem;
  -webkit-box-shadow: 0 0 0 0 transparent inset;
  box-shadow: 0 0 0 0 transparent inset;
  padding: 0.62em 1em;
  color: rgba(0, 0, 0, 0.87);
  -webkit-transition: color 0.1s ease, border-color 0.1s ease;
  transition: color 0.1s ease, border-color 0.1s ease;
`;
